<template>
  <div>
    <c-data-list v-if="tasks.length" :items="tasks">
      <template v-slot:columns>
        <div class="col-6 col-lg-1 col-xl-1">
          <p>Type</p>
        </div>
        <div class="col-12 col-lg-5 col-xl-5">
          <p>Task</p>
        </div>
        <div class="col-6 col-lg-2 col-xl-2">
          <p>Schedule</p>
        </div>
        <div class="col-6 col-lg-2 col-xl-2">
          <p>Next Run</p>
        </div>
        <div class="col-6 col-lg-2 col-xl-2 text-end">
          <p>Delivery</p>
        </div>
      </template>
      <template v-slot:default="slotProps">
        <div class="task-row">
          <div class="row">
            <div class="col-6 col-lg-1 col-xl-1">
              <p class="text-truncate">
                <span class="data-label d-lg-none">Type:</span>
                {{ slotProps.item.type === 'reminder' ? 'Reminder' : 'Agent' }}
              </p>
            </div>
            <div class="col-12 col-lg-5 col-xl-5">
              <p class="task-payload">
                <span class="data-label d-lg-none">Task:</span>
                {{ slotProps.item.payload }}
              </p>
            </div>
            <div class="col-6 col-lg-2 col-xl-2">
              <p class="text-truncate">
                <span class="data-label d-lg-none">Schedule:</span>
                {{ slotProps.item.cron ? slotProps.item.cron : 'One-off' }}
              </p>
            </div>
            <div class="col-6 col-lg-2 col-xl-2">
              <p class="text-truncate">
                <span class="data-label d-lg-none">Next Run:</span>
                {{ slotProps.item.run_at | moment('DD/MM/YYYY HH:mm') }}
              </p>
            </div>
            <div class="col-6 col-lg-2 col-xl-2 text-end">
              <p class="text-truncate">
                <span class="data-label d-lg-none">Delivery:</span>
                {{ slotProps.item.recipient ? slotProps.item.recipient : 'Slack DM' }}
              </p>
            </div>
          </div>
        </div>
      </template>
    </c-data-list>
    <div class="card" v-else>
      <div class="card-body">
        <p class="text-muted mb-0">
          No scheduled tasks. Ask the AI assistant to set one up - e.g. "remind me in 2 days to follow up the PO".
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { http } from 'utils'

export default {
  props: ['id'],

  data() {
    return {
      tasks: [],
    }
  },

  mounted() {
    this.load()
  },

  methods: {
    async load() {
      try {
        const { data } = await http.get(`users/${this.$route.params.id}/scheduled-tasks`)
        this.tasks = data.data
      } catch (error) {
        this.tasks = []
      }
    },
  },
}
</script>

<style scoped>
/* Non-clickable data-list rows miss the padding .list-data applies via "li a" */
.task-row {
  padding: 16px 24px;
}

.task-payload {
  white-space: pre-wrap;
  word-break: break-word;
}
</style>
